import * as requests from '../requests'

export const ADD_SENSOR = 'ADD_SENSOR'
export const ADD_SENSORS_FETCHED = 'ADD_SENSORS_FETCHED'
export const REMOVE_SENSOR = 'REMOVE_SENSOR'
export const UPDATE_SENSOR = 'UPDATE_SENSOR'
export const REMOVE_ALL_SENSORS = 'REMOVE_ALL_SENSORS'
export const ADD_SENSORS_FETCHED_ADMIN = 'ADD_SENSORS_FETCHED_ADMIN'
export const CHANGE_CHECKEDSTATE = 'CHANGE_CHECKEDSTATE'


export const getLatLon = (station, callback) => {
    requests.getLatLonStation(sessionStorage.getItem('x-auth-token'), station, callback);
};

/** MAP SENSOR ACTIONS **/
const addSensor = (sensor) => {
    return {
        type: ADD_SENSOR,
        sensor
    }
}

export const postSensor = (map, newSensor) => {
    return dispatch => {
        requests.postSensor(map, newSensor, (sensor) => {
            dispatch(addSensor(sensor))
        })
    }
}

export const deploySensors = (sensor, map) => {
    return dispatch => {
        requests.deploySensors(sensor, map, (deployedSensors) => {
            dispatch(addAdminSensors(deployedSensors))
        })
    }
}
export const fetchAdminSensors = (map) => {
    return dispatch => {
        requests.getAdminSensors(map, (sensors) => {
            dispatch(addAdminSensors(sensors))
        })

    }
}

export const fetchSensorsFromTimestamp = (map, timestamp) => {
    return dispatch => {
        requests.getSensorsFromtimestamp(map, timestamp, (sensors) => {
            dispatch(addSensors(sensors, sensors.length))
        })

    }
}

export const fetchSensors = (map) => {
    return dispatch => {
        requests.getSensors(map, (sensors) => {
            dispatch(addSensors(sensors, sensors.length))
        })
    }
}
const addAdminSensors = (sensors) => {
    return {
        type: ADD_SENSORS_FETCHED_ADMIN,
        sensors
    }
}
const addSensors = (sensors, count) => {
    return {
        type: ADD_SENSORS_FETCHED,
        sensors,
        count
    }
}

export const deleteSensor = (map, index, id) => {
    return dispatch => {
        requests.deleteSensor(map, id, () => {
            dispatch({
                type: REMOVE_SENSOR,
                index
            })
        })
    }
}

export const deleteAllSensors = (map) => {
    return dispatch => {
        requests.deleteAllSensors(map, (status) => {
            dispatch({
                type: REMOVE_ALL_SENSORS
            })
        })
    }
}

export const updateSensor = (map, value, index) => {
    return (dispatch, getState) => {
        const {sensors} = getState()
        const updatedSensor = {
            ...sensors.adminSensors[index],
            value
        };
        requests.updateSensor(map, updatedSensor, (sensor) => {
            dispatch({
                type: UPDATE_SENSOR,
                index,
                sensor
            })
        })
    }
};

/** NEW SENSOR ACTIONS **/


// export const getDeviceList = (token, pag) => {
//     return (dispatch) => {
//         requests.getDeviceList(token, pag, (response, error) => {
//             if (error && response.status !== 401) {
//                 dispatch(addSensors([], 0))
//             } else if (error && response.status === 401) {
//                 dispatch(setLoggedOutUser())
//             } else {
//                 dispatch(addSensors(response.data.nodes, response.data.count))
//             }
//         })
//     };
// };

export const modifyCheckedState = (key) => {
    return {
        type: CHANGE_CHECKEDSTATE,
        key
    }
};

// export const postDevice = (token, entity, callback) => {
//     return (dispatch) => {
//         requests.postDevice(token, entity, (response, error) => {
//             if (error && response.status === 401)
//                 dispatch(setLoggedOutUser());
//             else
//                 callback(response, error);
//         });
//     }
// };

// export const updateDevice = (token, deviceId, entity, callback) => {
//     return (dispatch) => {
//         requests.updateDeviceDetails(token, deviceId, entity, (response, error) => {
//             if (error && response.status === 401)
//                 dispatch(setLoggedOutUser());
//             else
//                 callback(response, error);
//         })
//     }
// };

// export const getAllDevices = () => {
//     return dispatch => {
//         let nodes = [];
//         let recursive = (pag) => {
//             requests.getDeviceList(localStorage.getItem('x-auth-token'), pag, (response, err) => {
//                 if (!err && response.data.nodes.length > 0) {
//                     nodes.push(...response.data.nodes);
//                     recursive(pag + 20);
//                 } else {
//                     dispatch(addSensors(nodes, nodes.length))
//                 }
//             })
//         };
//
//         recursive(0);
//
//     }
// };

export const moveSensor = (map, latLng, index) => {
    return (dispatch, getState) => {
        const {sensors} = getState();
        const updatedSensor = {
            ...sensors.adminSensors[index]
        };
        updatedSensor.location = {
            ...updatedSensor.location,
            coordinates: [latLng.lat, latLng.lng],
            x: latLng.lat,
            y: latLng.lng
        };
        requests.updateSensor(map, updatedSensor, (sensor, err) => {
            if (!err)
                dispatch({
                    type: UPDATE_SENSOR,
                    index,
                    sensor
                })
        })
    }
};


// WEBPACK FOOTER //
// ./src/actions/sensors.js